import React from "react";

import { formatDocument } from "utils/formatDoc";
// PO1-3106: Row/Badge (e o CSS onb-clrow/onb-badge) viraram componente
// compartilhado para o painel de habilitação da transportadora. Visual igual.
import Row, { Badge } from "components/ChecklistRow";

import KitArquivosSection from "./KitArquivosSection";

// Checklist retomável do onboarding (PO1-2428). Estado dos passos é derivado
// do dado no backend — sair e voltar não perde nada. Passos das próximas
// histórias aparecem bloqueados com a referência do ticket.
export default function ChecklistHome({ dados, onOpenStep }) {
  const { embarcador, checklist } = dados;
  const passos = [
    {
      key: "produto",
      titulo: "Produto / Plano",
      sub: "Módulos contratados (FLOW + add-ons)",
      done: checklist.produto.done,
    },
    {
      key: "identidade",
      titulo: "Identidade da matriz",
      sub: "CNPJ via BrasilAPI",
      done: checklist.identidade.done,
    },
    {
      key: "filiais",
      titulo: "Filiais / plantas",
      sub: "Remetentes que embarcam",
      done: checklist.filiais.done,
    },
    {
      key: "usuarios",
      titulo: "Usuários",
      sub: "Convite por email (senha pelo usuário)",
      done: checklist.usuarios.done,
    },
    {
      key: "transportadoras",
      titulo: "Transportadoras",
      sub: "Cadastro, 3 contatos e parâmetros por transportadora",
      done: checklist.transportadoras.done,
    },
    {
      key: "configuracao",
      titulo: "Configuração automática",
      sub: "Parâmetros, fiscal, local de arquivo, credencial",
      done: checklist.configuracao.done,
    },
  ];

  const concluidos = passos.filter((p) => p.done).length;
  const operacional = checklist.statusEmbarcador === "OPERACIONAL";

  // PO1-2746: estado do kit enviado ao sponsor — somente leitura (não abrem
  // tela própria, só refletem o que chegou pelo link público de upload).
  const kitSponsor = checklist.kitSponsor || {};
  const kitItens = [
    { titulo: "Kit enviado ao sponsor", done: !!kitSponsor.enviado },
    { titulo: "Planilha recebida", done: !!kitSponsor.planilhaRecebida },
    { titulo: "Base de movimento recebida", done: !!kitSponsor.baseRecebida },
    { titulo: "Tabelas de preço recebidas", done: !!kitSponsor.tabelasRecebidas },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div>
          <h4 style={{ marginBottom: 0 }}>{embarcador.fantasia}</h4>
          <small style={{ color: "#9a9a9a" }}>
            CNPJ {formatDocument(embarcador.cnpjCpf)}
          </small>
        </div>
        <Badge tipo={operacional ? "done" : "pend"}>
          {checklist.statusEmbarcador}
        </Badge>
      </div>
      <p style={{ fontSize: 12, color: "#9a9a9a", marginBottom: 18 }}>
        {concluidos} de {passos.length} passos concluídos
      </p>

      {passos.map((passo, i) => (
        <Row
          key={passo.key}
          numero={i + 1}
          titulo={passo.titulo}
          sub={passo.sub}
          done={passo.done}
          locked={passo.locked}
          badge={
            passo.done
              ? "Concluído"
              : passo.locked
              ? passo.lockedLabel
              : "Pendente"
          }
          badgeTipo={passo.done ? "done" : passo.locked ? "lock" : "pend"}
          onClick={() => onOpenStep(passo.key)}
        />
      ))}

      <hr />
      <p style={{ fontSize: 12, color: "#9a9a9a", marginBottom: 4 }}>
        Kit de onboarding (envio ao sponsor)
      </p>
      {kitItens.map((item) => (
        <Row
          key={item.titulo}
          numero="●"
          titulo={item.titulo}
          sub=""
          done={item.done}
          locked={!item.done}
          badge={item.done ? "Concluído" : "Pendente"}
          badgeTipo={item.done ? "done" : "lock"}
          onClick={() => {}}
        />
      ))}
      {/* PO1-2896: o que o cliente enviou pelo link, direto do SFTP. Também
          para onboarding OPERACIONAL. */}
      <KitArquivosSection
        idEmbarcador={embarcador.id}
        apelido={embarcador.fantasia || embarcador.razaoSocial}
      />

      <hr />
      <Row
        numero="✓"
        titulo="Homologação"
        sub="Gate final do Projeto, ativa o embarcador"
        done={checklist.homologacao.done}
        locked={!checklist.produto.done || !checklist.usuarios.done}
        badge={
          checklist.homologacao.done
            ? "Concluído"
            : checklist.produto.done && checklist.usuarios.done
            ? "Pronto"
            : "Bloqueado"
        }
        badgeTipo={
          checklist.homologacao.done
            ? "done"
            : checklist.produto.done && checklist.usuarios.done
            ? "pend"
            : "lock"
        }
        onClick={() => onOpenStep("homologacao")}
      />

      <p style={{ fontSize: 12, color: "#9a9a9a", marginTop: 14 }}>
        Operado pelo <b>Projeto</b>, no mesmo fluxo que o cliente usará no
        self-service. O embarcador fica <b>PENDENTE</b> até a homologação.
      </p>
    </div>
  );
}
